import { render, staticRenderFns } from "./add.vue?vue&type=template&id=14fda4cb&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"
import style0 from "./add.vue?vue&type=style&index=0&id=14fda4cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fda4cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14fda4cb')) {
      api.createRecord('14fda4cb', component.options)
    } else {
      api.reload('14fda4cb', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=14fda4cb&scoped=true&", function () {
      api.rerender('14fda4cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchantMember/role/add.vue"
export default component.exports